<template>
  <div
    class="share-tip"
    v-if="showTip"
    :class="{'share-tip_wx':shareStyle === 'wx','share-tip_minwx':shareStyle === 'minWx'}"
    @click="hideTip"
  >
    <img src="../assets/img/share-tip.png" alt />
  </div>
</template>

<script>
export default {
  name: "shareTip",
  props: {
    showTip: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      shareStyle: ""
    };
  },
  methods: {
    hideTip() {
      this.$emit("hideTip");
    }
  },
  created() {},
  mounted() {
    if (this.$browser().miniprogram) {
      this.shareStyle = "minWx";
    } else if (this.$browser().wx) {
      this.shareStyle = "wx";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.share-tip {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  img {
    float: right;
  }
  &_wx {
    img {
      width: 80%;
      margin: 10px 10px 0 0;
    }
  }
  &_minwx {
    img {
      width: 70%;
      margin: 10px 76px 0 0;
    }
  }
}
</style>
